import { ProductOption } from '@repobit/dex-store';
import { OptionInfo, ProductLoadedEventProductObject } from './typeDefinitions';

export class ProductLoadedEvent  {
  event  : 'product loaded' | 'campaign product';
  product: ProductLoadedEventProductObject = {};

  constructor(option: ProductOption | { ID: string }, type: 'all' | 'info' | 'comparison' | string, event: 'product loaded' | 'campaign product' = 'product loaded') {
    this.event = event;
    if (!this.product[type]) {
      this.product[type] = [];
    }

    if ('ID' in option) {
      this.product[type].push(option);
    } else {
      this.product[type].push(this.getOptionInfo(option));
    }
  }

  protected getOptionInfo(option: ProductOption): OptionInfo {
    const product = option.getProduct();
    return {
      ID            : product.getPlatformId(),
      name          : product.getName(),
      devices       : option.getDevices(), //DEPRECATED content - please remove after Vlaicu implementation
      subscription  : option.getSubscription(),
      version       : option.getSubscription() === 1 ? "monthly" : "yearly",
      basePrice     : option.getPrice({ currency: false }),
      discountValue : option.getDiscount({ symbol: false }),
      discountRate  : option.getDiscount({ percentage: true, symbol: false }),
      currency      : product.getCurrency(),
      grossPrice    : option.getDiscountedPrice({ currency: false }) || option.getPrice({ currency: false }),
      discountCoupon: product.getCampaignType()
        ? `${product.getCampaignType()}|${product.getCampaign()}`
        : (product.getCampaign() || '')
    };
  }
}